<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row border-bottom mb-3">
              <div class="col-md-12">
                <b-form @submit.prevent="listEnvios">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group label="Evento" label-for="filtros-evento">
                        <select id="filtros-evento"
                                @change="listEnvios"
                                v-model="filtros.evento"
                                class="custom-select" type="text">
                          <option value="false">Normal</option>
                          <option value="true">Cancelamento</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Status" label-for="filtros-status">
                        <select id="filtros-status"
                                @change="listEnvios"
                                v-model="filtros.status"
                                class="custom-select" type="text">
                          <option value="">Todos</option>
                          <option value="false">Rejeitado</option>
                          <option value="true">Enviado</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label="Número"
                          label-for="codigo">
                        <input
                            id="codigo"
                            v-model="filtros.numero"
                            type="text"
                            maxlength="10"
                            class="form-control"
                            placeholder="Número final">
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="'" class="text-white" label-for="lgd_reenviado">
                        <b-form-checkbox v-model="filtros.lgd_reenviado" class="text-dark mt-3 mb-2 mr-sm-3">
                          Reenviados
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group label="Envios por Página" label-for="nota_pagina">
                        <select id="nota_pagina"
                                @change="listEnvios"
                                v-model="filtros.nota_pagina"
                                class="custom-select" type="text">
                          <option value="10">10/Pág.</option>
                          <option value="30">30/Pág.</option>
                          <option value="50">50/Pág.</option>
                          <option value="80">80/Pág.</option>
                          <option value="100">100/Pág.</option>
                          <option value="200">200/Pág.</option>
                          <option value="500">500/Pág.</option>
                          <option value="800">800/Pág.</option>
                          <option value="1000">1000/Pág.</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-9">
                      <b-form-group label="'" class="text-white">
                        <button type="button" @click="listEnvios()" class="btn btn-label btn-primary mb-3 mr-3"><i
                            class="bx bx-search label-icon"></i>
                          Pesquisar
                        </button>
                        <button type="button" @click="listEnvios()" class="btn btn-label btn-light mb-3 mr-3"><i
                            class="bx bx-sync label-icon"></i>
                          Atualizar
                        </button>
                        <button type="button" @click="reenviar()" class="btn btn-label btn-success mb-3"><i
                            class="bx bx-send label-icon"></i>
                          Reenviar
                        </button>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <div v-if="envios && envios.length > 0" class="row">
              <div class="col-md-12">
                <div class="row border-bottom border-secondary mb-1">
                  <p class="mb-2 font-weight-medium">Total de NFS-e: {{total_notas}} </p>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-centered mb-0">
                    <thead>
                    <tr>
                      <th class="border-top-0">Situação/Data</th>
                      <th class="border-top-0">Número</th>
                      <th class="border-top-0">Detalhe</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="p in envios" :key="p.lgd_codigo">
                      <td>
                        <span v-show="p.ldg_sucesso==='t'" class="badge badge-info font-size-11">Aprovado</span>
                        <span v-show="p.ldg_sucesso==='f'" class="badge badge-danger font-size-11">Rejeitado</span>
                        <p v-show="p.lgd_reenviado==='f'" class="text-muted mb-0">{{ p.datahora }}</p>
                        <p v-show="p.lgd_reenviado==='t'" class="text-muted mb-0">{{ p.datahora_reenviado }}</p>
                      </td>
                      <td>
                        <h5 class="text-truncate font-size-12 mb-1">
                          NFS-e <span v-show="p.lgd_reenviado === 't'" class="badge badge-success font-size-10 mr-1">Reenviado</span>
                                <span v-show="p.lgd_cancelamento ==='t'" class="badge badge-warning font-size-10">Cancelamento</span>
                        </h5>
                        <router-link
                            tag="a"
                            :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: p.not_hash}}">
                          {{ p.not_numero }}
                        </router-link>
                      </td>

                      <td v-if="p.lgd_detalhe">
                        <h5 v-show="p.ldg_sucesso==='t'" class="text-truncate font-size-12 mb-1">
                          {{ p.lgd_detalhe.mensagem }}
                        </h5>
                        <h5 v-show="p.ldg_sucesso==='f'" class="text-truncate font-size-12 mb-1">
                          <span v-show="!p.lgd_detalhe.status">{{ p.lgd_detalhe.mensagem }}</span>
                          <span v-show="p.lgd_detalhe.status">Erro no Processamento</span>
                        </h5>
                        <p v-if="p.lgd_detalhe.lote" class="text-muted mb-0">
                          <span v-if="p.lgd_detalhe.lote.Lote">{{ p.lgd_detalhe.lote.Lote[0].Erros }}</span>
                        </p>
                        <p v-else class="text-muted mb-0">{{ p.lgd_detalhe }}</p>
                      </td>
                      <td v-else>
                        <p class="text-muted mb-0">Sem Detalhes</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-lg-12">
                <paginate
                    :page-count="total_paginas"
                    :page-range="3"
                    :margin-pages="3"
                    :click-handler="proximaPagina"
                    :prev-text="'Página anterior'"
                    :next-text="'Próxima página'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                    :page-link-class="'page-link'"
                    :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                    :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-sm-12">
                <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
                  <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhum envio
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Paginate from 'vuejs-paginate'
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {listEnviosAdn, reenviarAdn} from "@/api/admin/gestao/nfse_nacional";
import {notifyErro, notifySucesso} from "@/helps/notificacao";

export default {
  page: {
    title: "NFS-e Nacional",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Paginate
  },
  data() {
    return {
      title: "Compartilhamento de Notas Fiscais com Ambiente de Dados Nacional",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'NFS-e Nacional',
          active: true,
        },
      ],
      httpSend: false,
      filtros: {
        pagina: 1,
        status: 'false',
        evento: false,
        numero: "",
        nota_pagina: "10",
        lgd_reenviado: false
      },
      total_paginas: 0,
      total_notas: 0,
      envios: []
    };
  },
  created() {
    this.listEnvios();
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtros.pagina = pageNum;
      this.listEnvios()
    },
    listEnvios() {
      this.httpSend = true;
      listEnviosAdn(this.filtros).then(result => {
        if (result.status) {
          this.total_notas = result.dados.total;
          this.total_paginas = result.dados.paginas;
          this.envios = result.dados.envios;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    reenviar() {
      this.httpSend = true;
      const enviar = this.envios.map(({lgd_codigo, not_hash, lgd_cancelamento}) => ({lgd_codigo, not_hash, lgd_cancelamento}));
      reenviarAdn(enviar).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
          this.listEnvios()
        } else {
          notifyErro("Erro ao Reenviar", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


